import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state() {
    return {
      userName: '',
      userId: ''
    }
  },
  getters: {
    getUser(state) {
      return state.userName
    },
    getUserId(state) {
      return state.userId
    }
  },
  mutations: {
    setUser(state, data) {
      state.userName = data
    },
    setUserId(state, data) {
      state.userId = data
    }
  },
  actions: {
    setUser({ commit }, data) {
      commit('setUser', data)
    },
    setUserId({ commit }, data) {
      commit('setUserId', data)
    }
  },
  modules: {
    // 如果有子模块，写这里
  },
  plugins: [
    createPersistedState({
      reducer(val) {
        return {
          userName: val.userName,
          userId: val.userId
        }
      }
    })
  ]
})
